export default function Select({
  type,
  placeholder,
  name,
  register,
  errors,
  rules,
  label,
  children,
  disabled = false,
  defaultValue,
  ...rest
}: {
  type: string;
  placeholder: string;
  name: string;
  register: any;
  errors: any;
  rules?: any;
  label?: string;
  children: any;
  disabled?: boolean;
  defaultValue?: string;
}) {
  return (
    <div>
      {label && (
        <label>
          {label} {rules?.required && <span className="text-red-600">*</span>}
        </label>
      )}
      <select
        placeholder={placeholder}
        className={`${errors[name] && "input-invalid"}`}
        defaultValue={defaultValue}
        disabled={disabled}
        {...register(name, rules)}
        {...rest}
      >
        {children}
      </select>
      {errors[name] && (
        <small className="mt-1.5 text-red-600 block">
          {errors[name].message || "This field is required"}
        </small>
      )}
    </div>
  );
}
